// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"6ac211e5","938":"3cf60c69"}[chunkId] + ".chunk.js";
};